export default "/packs/images/gym-class~49e160f952dde43a35a14c4b9157d457.jpg";